import { render, staticRenderFns } from "./annex-import-config.vue?vue&type=template&id=46ab4070&scoped=true"
import script from "./annex-import-config.vue?vue&type=script&lang=ts"
export * from "./annex-import-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab4070",
  null
  
)

export default component.exports